import React from "react";
import type {
  DateValue,
  RangeCalendarProps as HeadlessRangeCalendarProps,
} from "react-aria-components";
import {
  CalendarGrid as HeadlessCalendarGrid,
  CalendarGridBody as HeadlessCalendarGridBody,
  CalendarGridHeader as HeadlessCalendarGridHeader,
  RangeCalendar as HeadlessRangeCalendar,
} from "react-aria-components";
// Relative imports (not the "@appsmith/wds" barrel) keep this component out
// of the package-barrel dependency cycle counted by the CI cyclic-deps gate.
import {
  calendarStyles,
  CalendarCell,
  CalendarHeaderCell,
  CalendarHeading,
} from "../../Calendar";
import { Flex } from "../../Flex";
import { IconButton } from "../../IconButton";

type RangeCalendarProps<T extends DateValue> = HeadlessRangeCalendarProps<T>;

/**
 * RangeCalendar wrap for the DateRangePicker popover. Reuses the Calendar
 * subcomponents (CalendarCell/CalendarHeading/CalendarHeaderCell) and the
 * Calendar's styles so single- and range-calendars stay visually identical.
 */
export const RangeCalendar = <T extends DateValue>(
  props: RangeCalendarProps<T>,
) => {
  return (
    <HeadlessRangeCalendar {...props} className={calendarStyles.calendar}>
      <Flex alignItems="center" justifyContent="space-between" width="100%">
        <IconButton icon="chevron-left" slot="previous" variant="ghost" />
        <CalendarHeading size="subtitle" />
        <IconButton icon="chevron-right" slot="next" variant="ghost" />
      </Flex>
      <HeadlessCalendarGrid>
        <HeadlessCalendarGridHeader>
          {(day) => <CalendarHeaderCell>{day}</CalendarHeaderCell>}
        </HeadlessCalendarGridHeader>
        <HeadlessCalendarGridBody>
          {(date) => <CalendarCell date={date} />}
        </HeadlessCalendarGridBody>
      </HeadlessCalendarGrid>
    </HeadlessRangeCalendar>
  );
};
